import ApplePodcasts from "@/icons/ApplePodcasts.vue"
import LawHub from "@/icons/LawHub.vue"
import PictureInPicture from "@/icons/PictureInPicture.vue"
import Spinner from "@/icons/Spinner.vue"
import { BsCollectionPlayFill } from "vue3-icons/bs"
import {
  FaAmazon,
  FaBackwardStep,
  FaCalendar,
  FaCircleQuestion,
  FaClock,
  FaFacebook,
  FaFileLines,
  FaForwardStep,
  FaGoogle,
  FaList,
  FaPodcast,
  FaScroll,
  FaSpotify,
  FaSquareRss,
  FaTelegram,
  FaTwitter,
  FaWhatsapp,
} from "vue3-icons/fa6"
import { HiMiniQueueList } from "vue3-icons/hi2"
import { assign } from "lodash-es"

export default {
  add: "fa-plus",
  affiliation: "fa-briefcase",
  amazon: FaAmazon,
  announcement: "fa-bullhorn",
  applePodcasts: ApplePodcasts,
  arrowLeft: "fa-arrow-left",
  arrowLeftLong: "fa-arrow-left-long",
  arrowRight: "fa-arrow-right",
  arrowRightLong: "fa-arrow-right-long",
  backward: FaBackwardStep,
  bars: "fa-bars",
  chevronDown: "fa-chevron-down",
  chevronLeft: "fa-chevron-left",
  circleCheck: "fa-circle-check",
  circleWarning: "fa-circle-exclamation",
  clipboardListCheck: "fa-clipboard-list-check",
  close: "fa-xmark-large",
  copy: "fa-copy",
  course: "fa-graduation-cap",
  date: FaCalendar,
  decrease: "fa-circle-minus",
  delete: "fa-trash-can",
  duration: FaClock,
  edit: "fa-pen-to-square",
  ellipsis: "fa-ellipsis",
  ellipsisVertical: "fa-ellipsis-vertical",
  embed: "fa-code",
  episode: FaPodcast,
  error: "fa-circle-xmark",
  external: "fa-external-link",
  facebook: assign(FaFacebook, { class: "fill-[#1877f2]" }),
  feedback: "fa-comment",
  filter: "fa-sliders",
  forward: FaForwardStep,
  google: FaGoogle,
  guide: "fa-memo-circle-info",
  help: "fa-question-circle",
  host: "fa-microphone",
  increase: "fa-circle-plus",
  info: "fa-circle-info",
  lawhub: LawHub,
  link: "fa-link",
  list: FaList,
  loading: Spinner,
  location: "fa-location-dot",
  map: "fa-map",
  next: "fa-angle-right",
  notes: FaFileLines,
  page: "fa-file-lines",
  pip: PictureInPicture,
  play: "fa-circle-play",
  playlist: assign(BsCollectionPlayFill, { class: "stroke-none" }),
  previous: "fa-angle-left",
  queue: assign(HiMiniQueueList, { class: "stroke-none" }),
  remove: "fa-xmark",
  school: "fa-landmark",
  search: "fa-magnifying-glass",
  settings: "fa-gear",
  share: "fa-arrow-up-from-bracket",
  rss: assign(FaSquareRss, { class: "fill-[#ff9900] stroke-none" }),
  sms: "fa-comments",
  spotify: assign(FaSpotify, { class: "fill-[#1ed760] stroke-none" }),
  squareCheck: "fa-square-check",
  squareX: "fa-square-xmark",
  star: "fa-star",
  state: "fa-tree-city",
  tag: "fa-tag",
  telegram: assign(FaTelegram, { class: "fill-[#2aabee]" }),
  term: "fa-book",
  tip: "fa-lightbulb-on",
  transcript: FaScroll,
  trend: "fa-chart-line",
  troubleshoot: FaCircleQuestion,
  twitter: assign(FaTwitter, { class: "fill-[#1da1f2]" }),
  warning: "fa-triangle-exclamation",
  whatsapp: assign(FaWhatsapp, { class: "fill-[#25d366]" }),
}
